module.exports = __webpack_public_path__ + "static/media/ad-steadfast-bg.948ca94a.jpg";